var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('ul',{staticClass:"navlinks"},_vm._l((_vm.menuItems),function(menuitem){return _c('NavBarItem',{key:menuitem.id,attrs:{"item":menuitem}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }